import React from 'react';
import { weekDayAndHour, msToHour } from '../../../lib/date.utils';

const LineupSearchResults = ({ results, editPerformance }) => (
    <div className="ckp-admin-lineup-search-results">
        <ul>
            {results.map((entry) => (
                <li onClick={() => editPerformance(entry)} key={entry.id} className="ckp-events-search-item">
                    <span className="ckp-events-search-artist">{(entry.Artist && entry.Artist.name) || ''}</span>
                    <span className="ckp-events-search-date">
                        {weekDayAndHour(entry.date, msToHour(entry.startHour), msToHour(entry.endHour), true)}
                    </span>
                    <span className="ckp-events-search-stage">{entry.stageName}</span>
                </li>
            ))}
        </ul>
    </div>
);

export default LineupSearchResults;



// WEBPACK FOOTER //
// ./src/components/admin/lineup/LineupSearchResults.js